<template>
    <div>
        <Row :gutter="10">
            <Col span="5">
                <Select v-model="platform" filterable :placeholder="$t( 'resourceLifecycle.filterbycloudplatform')" :transfer="true" @on-change="searchPlatform()">
                    <Option value="">{{$t('ApprovalTask.selectAll')}}</Option>
                    <Option :value="item.id" v-for="item in platformList" :key="item.id">{{item.name}}</Option>
                </Select>
            </Col>
            <Col span="6">
                <add-resource-price-coefficient></add-resource-price-coefficient>
            </Col>
        </Row>
    </div>
</template>
<script>
    import TableResourcePriceCoefficient from '../resource_price_coefficient/TableResourcePriceCoefficient'
    import AddResourcePriceCoefficient from '../resource_price_coefficient/AddResourcePriceCoefficient'
    var tableResourcePriceCoefficient = TableResourcePriceCoefficient;
    export default {
        name: 'ResourcePriceCoefficientSearch',
        components: {
            AddResourcePriceCoefficient
        },
        data () {
            return {
                platform: '',
                platformList: [{
                    id: 0,
                    name: 'AWS'
                }, {
                    id: 2,
                    name: 'Azure'
                }]
            }
        },
        methods: {
            searchPlatform: function(){
                // 在需要传递参数的组件中，定义一个emit发送需要传递的值，键名可以自己定义（可以为对象）
                eventBus.$emit('platform', this.platform);
                tableResourcePriceCoefficient.methods.showAll();
            }
        }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/resource_lifecycle_management/resource_service_operation_report/resource_price_coefficient/ResourcePriceCoefficientSearch.vue